<script setup>
import ButtonBase from "../general/ButtonBase.vue";

defineProps({ blok: Object });
</script>

<template>
  <v-col cols="12" sm="6" md="3" class="home__card text-center mb-8 mb-md-0">
    <div
      class="d-flex flex-column h-100 px-6 py-10"
      :class="[blok?.highlighted ? 'bg-primary' : '']"
    >
      <div
        class="home__card--icon rounded-circle d-flex justify-center mx-auto bg-lightGray"
      >
        <div class="d-flex justify-center align-center">
          <img
            class="h-75 w-75"
            :src="blok?.icon?.filename"
            :alt="blok?.icon?.alt"
          />
        </div>
      </div>
      <h2
        class="font-weight-bold mt-4"
        :class="[blok?.highlighted ? 'text-white' : 'text-primary']"
      >
        {{ blok?.title }}
      </h2>
      <p
        class="mt-4 mb-6 text-medium-emphasis"
        :class="[blok?.highlighted ? 'text-white' : 'text-primary']"
      >
        {{ blok?.description }}
      </p>
      <div class="mt-auto">
        <ButtonBase
          class="text-none elevation-0 bg-primary font-weight-bold mt-4"
          :buttonTitle="blok?.buttonText"
          :buttonUrl="
            blok.buttonUrl.url
              ? blok.buttonUrl.url
              : '/' + blok.buttonUrl.cached_url
          "
          :rel="
            blok.buttonUrl?.target === '_blank' ? 'nofollow noreferrer' : ''
          "
          :target="blok.buttonUrl?.target"
          :variant="[blok?.highlighted ? 'outlined' : '']"
        />
      </div>
    </div>
  </v-col>
</template>

<style scoped lang="scss">
.home__card {
  &--icon {
    height: 100px;
    width: 100px;
  }
}
</style>
